import React from "react";

const CustomerErrorMessage = () => {
    return (
        <React.Fragment>
            We were unable to lookup your customer information based on the provided serial numbers. Please contact our customer service department by email at <a href={"mailto:techsupport.omax.com"} style={{cursor: "pointer"}}>techsupport.omax.com</a> or call us at 800-298-4036, option 1.
        </React.Fragment>
    )
}

export default CustomerErrorMessage;